import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProfileTypesLoader = _resolveComponent("ProfileTypesLoader")!
  const _component_OAuth2Credentials = _resolveComponent("OAuth2Credentials")!
  const _component_AccountsLoader = _resolveComponent("AccountsLoader")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_ProfileTypesLoader, {
      onLoaded: _cache[0] || (_cache[0] = ($event: any) => (_ctx.profileTypes = $event))
    }),
    (_ctx.profileType)
      ? (_openBlock(), _createBlock(_component_OAuth2Credentials, {
          key: 0,
          platform: "salesforce",
          permissions: _ctx.permissions,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.credentials = $event))
        }, null, 8, ["permissions"]))
      : _createCommentVNode("", true),
    (_ctx.credentials)
      ? (_openBlock(), _createBlock(_component_AccountsLoader, {
          key: 1,
          platform: "salesforce",
          auth: { type: 'OAUTH', version: '2.0' },
          credentials: _ctx.credentials,
          onLoaded: _ctx.onAccountsLoaded
        }, null, 8, ["credentials", "onLoaded"]))
      : _createCommentVNode("", true)
  ]))
}